/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-change-log-foreclsoure-auction .changeLog-bid-card{min-height:500px;margin-left:22%;max-height:auto}app-change-log-foreclsoure-auction .date-range-section{padding:.5em;margin-top:.6em}app-change-log-foreclsoure-auction .date-range-title{font-size:12px;margin-left:3px}app-change-log-foreclsoure-auction .changeLogList{width:12rem!important}app-change-log-foreclsoure-auction .formFields{padding-right:2%;padding-bottom:2%}"];
export { styles as styles };
